import { MasterOutlet, MasterOutletUpdate } from '@app/api/models/acb';

import { FIELDS } from '../../history/contants';

const labels: Record<string, string> = {
  ...FIELDS, phone: 'Телефон ТТ', status_id: 'Статус ТТ', sub_channel_id: 'Подканал',
  route_number_id: 'Маршрут', route_numbers: 'Маршруты', visits_frequency: 'Частота посещений',
};

const display = (value: unknown): string => {
  if (value === undefined) { return 'Нет данных'; }
  if (value === null || value === '') { return '—'; }
  if (Array.isArray(value)) { return value.map(display).join(', ') || '—'; }
  if (typeof value === 'object') {
    const item = value as Record<string, unknown>;
    if (item.name !== undefined) { return display(item.name); }
    if (item.full_address) { return display(item.full_address); }
    return Object.values(item).filter((part) => part !== null && part !== '').map(display).join(', ') || '—';
  }
  if (typeof value === 'boolean') { return value ? 'Да' : 'Нет'; }
  return String(value);
};

export const requestChanges = (request: MasterOutletUpdate, outlet: MasterOutlet | undefined,
  previousId: number | undefined, names: Record<number, string>) => {
  const rows: { key: string; label: string; before: string; after: string }[] = [];
  const distributor = (id?: number) => id ? `${names[id] || 'Название не получено'} (ID ${id})` : 'Нет данных';
  const nextId = request.data?.distributors?.find((item) => item.is_general)?.id;
  if (nextId && nextId !== previousId) {
    rows.push({ key: 'distributors', label: 'Основной дистрибьютор', before: distributor(previousId), after: distributor(nextId) });
  }
  const source: Record<string, unknown> = {
    ...outlet, status_id: outlet?.status?.id, sub_channel_id: outlet?.sub_channel?.id,
    ...request.data_before,
  };
  Object.entries(request.data || {}).forEach(([key, value]) => {
    if (!labels[key] || value === undefined) { return; }
    const before = source[key];
    if (JSON.stringify(before) === JSON.stringify(value)) { return; }
    rows.push({ key, label: labels[key], before: display(before), after: display(value) });
  });
  return rows;
};
